import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

const RelievingLetterDialog = ({ open, onClose, onSubmit, employee }) => {
  const [formData, setFormData] = useState({
    closing_date: "",
    supervisor_name: "",
    designation: "",
  });

  const handleChange = (field) => (e) =>
    setFormData({ ...formData, [field]: e.target.value });

  const handleSubmit = () => {
    onSubmit(employee, formData);
    setFormData({ closing_date: "", supervisor_name: "", designation: "" });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Generate Relieving Letter</DialogTitle>
      <DialogContent dividers>
        <TextField
          margin="dense"
          label="Closing Date (e.g. 31-DEC-2025)"
          fullWidth
          value={formData.closing_date}
          onChange={handleChange("closing_date")}
        />
        <TextField
          margin="dense"
          label="Authorized Name"
          fullWidth
          value={formData.supervisor_name}
          onChange={handleChange("supervisor_name")}
        />
        <TextField
          margin="dense"
          label="Authorized Position"
          fullWidth
          value={formData.designation}
          onChange={handleChange("designation")}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RelievingLetterDialog;
